import "./Navbar.css";
import {useRecoilValue} from "recoil";
import User from "../../Model/User";
import { useUserActions } from "../../../Connect/_actions";
import { Role } from "../../Useful/enum";
import { userAtom } from "../../RecoilApp";
import Loc from "../../../Loc/Loc";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { Language } from "../../../Loc/Language";
import logo from "../../assets/Logo Fives Blanc.png";

interface NavbarProps {
    page: string;
    setPageOnClick: (page: string) => void;
    setLanguage: (language: Language) => void;
}

export default function Navbar (props: NavbarProps) {

    const user: User = useRecoilValue(userAtom);
    const userActions = useUserActions();

    function define_color(currentPage: string, page: string) {
        if (currentPage === page) {
            return ("white");
        }
        return ("");
    }

    const HandleButtonDisconnectOnClick = () => {
        userActions.logout();
    }

    return (
        <nav className="Navbar">
            <ul className="Navbar-ul">
                {
                    (user.role === Role.PermUser ?
                        <div>
                            <img src={logo} alt="logo Fives" style={{minWidth: "5%", maxWidth: "100px", float: "left"}}/>
                            <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("Home")} style={{ color: define_color(props.page, "Home") }}>{Loc.trad().NavbarHomepage}</li>
                            <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("RecepDocs")} style={{ color: define_color(props.page, "RecepDocs") }}>{Loc.trad().NavbarReceive}</li>
                            <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("SendDocs")} style={{ color: define_color(props.page, "SendDocs") }}>{Loc.trad().NavbarSending}</li>
                            {/*<li className="Navbar-ul-li" onClick={() => props.setPageOnClick("ExternalDocs")} style={{ color: define_color(props.page, "ExternalDocs") }}>{Loc.trad().NavbarExternal}</li>*/}
                            <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("MyAccount")} style={{ color: define_color(props.page, "MyAccount") }}>{user.firstName}</li>
                            <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("FivesPolicy")} style={{ color: define_color(props.page, "FivesPolicy") }}>{Loc.trad().NavbarPolicy}</li>
                            <li className="Navbar-ul-li"><LanguageSelector setLanguage={props.setLanguage} color="white"></LanguageSelector> </li>

                            <button className="btn btn-secondary" onClick={HandleButtonDisconnectOnClick} style={{ margin: "2vh" }}>{Loc.trad().NavbarDisconnect}</button>
                        </div> :
                        <li className="Navbar-ul-li" onClick={() => props.setPageOnClick("ModifPassword")} style={{ color: "white" }}>{Loc.trad().NavbarFirst}</li>
                    )
                }
            </ul>
        </nav>
    );
}